import { useMutation } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { ArticleRequest } from '../../api/queries';

export enum PublishArticleMutationCacheKey {
  PublishArticle = 'PublishArticle',
}

export const usePublishArticleMutation = () => {
  const { publishArticle } = useServicesContext();
  return useMutation({
    mutationKey: [PublishArticleMutationCacheKey.PublishArticle],
    mutationFn: ({ article }: { article: ArticleRequest }) =>
      publishArticle({ article }),
  });
};
